import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import moment from 'moment';
import 'moment/locale/pt-br';
import uid from 'uid';
import BraftEditor from 'braft-editor';
import 'braft-editor/dist/index.css';
import styled from 'styled-components';

import {
    Input,
    Button,
    Form,
    Row,
    Col,
    Drawer,
    Divider,
    Progress,
    Icon,
    Switch,
    DatePicker,
} from 'antd';

import { Cod } from '~/components/UI';
import TodoList from '~/components/TodoList';
import * as drawerBoard from './actions';

const StyledBraftEditor = styled(BraftEditor)`
    .bf-controlbar {
        border: 1px solid #d9d9d9;
        border-radius: 4px 4px 0 0;
        background-color: #fafafa;
    }
    .bf-content {
        border: 1px solid #d9d9d9;
        border-radius: 0 0 4px 4px;
        min-height: 80px;
        padding: 10px;
    }
`;

const DrawerBoardItem = ({
    form,
    drawer,
    marketing,
    dispatchClose,
    dispatchCreate,
    dispatchSave,
    dispatchDelete
}) => {

    const { getFieldDecorator } = form;
    const { data } = drawer;
    const currentBoardType = marketing.currentBoardType;

    const [tasks, setTasks] = useState([]);
    const [loading, setLoading] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);

    useEffect(() => {
        setTasks([]);
        if (get(data, 'tasks')) {
            setTasks(data.tasks);
        }
    }, [data]);

    const closeDrawer = () => {
        form.resetFields();
        dispatchClose();
    }

    const handleCreate = () => {
        setLoading(true);
        form.validateFields((err, values) => {
            if (!err) {
                const formattedValues = {
                    ...values,
                    tasks,
                    created_at: values.created_at ? values.created_at.format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
                    description: values.description ? values.description.toHTML() : ''
                };
                dispatchCreate(formattedValues, currentBoardType).then(() => {
                    setLoading(false);
                    closeDrawer();
                });
            }
        });
    }

    const handleSave = () => {
        setLoading(true);
        form.validateFields((err, values) => {
            if (!err) {
                const formattedValues = {
                    ...values,
                    tasks,
                    created_at: values.created_at ? values.created_at.format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
                    description: values.description ? values.description.toHTML() : ''
                };
                dispatchSave(data.id, formattedValues, currentBoardType).then(() => {
                    setLoading(false);
                    closeDrawer();
                });
            }
        });
    }

    const handleDelete = () => {
        setDeleteLoading(true);
        dispatchDelete(data, currentBoardType).then(() => {
            setDeleteLoading(false);
            closeDrawer();
        });
    }

    const progress = tasks.length > 0 ? (tasks.filter(task => task.done).length / tasks.length) * 100 : 0;

  return (
    <Drawer
      title={(data.id) ? <span>Editar Item <Cod float="right">#{data.id}</Cod></span> : 'Cadastrar Item'}
      width={800}
      placement="right"
      onClose={closeDrawer}
      maskClosable={false}
      visible={drawer.show}
      destroyOnClose={true}
      style={{
        height: '100%',
        overflow: 'auto',
      }}
      bodyStyle={{ paddingBottom: '100px' }}
      >
        <Form layout="vertical">
            <Row gutter={16}>
                <Col span={24}>
                    <Form.Item label="Título">
                        {getFieldDecorator('title', {
                        initialValue: get(data, 'title'),
                        rules: [{ required: true, message: 'Por favor informe um título' }],
                        })(<Input placeholder="Título" />)}
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label="Criado Em:">
                        {getFieldDecorator('created_at', {
                            initialValue: get(data, 'created_at') ? moment(get(data, 'created_at')) : moment(),
                            rules: [{ required: true, message: 'Por favor selecione uma data' }],
                        })(
                            <DatePicker 
                                format="DD/MM/YYYY" 
                                placeholder="Selecione a data"
                                style={{ width: '100%' }}
                            />
                        )}
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label="Revisado">
                    {getFieldDecorator('is_revised', {
                            initialValue: get(data, 'is_revised', false),
                            valuePropName: 'checked'
                        })(
                            <Switch />
                        )}
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item label="Descrição">
                        {getFieldDecorator('description', {
                            initialValue: BraftEditor.createEditorState(get(data, 'description')),
                        })(
                            <StyledBraftEditor
                                className="my-editor"
                                placeholder="Descrição"
                                language="pt-br"
                                controls={['bold', 'italic', 'underline', 'text-color', 'separator', 'link', 'separator', 'list-ul', 'list-ol']}
                            />
                        )}
                    </Form.Item>
                </Col>
            </Row>
            <Divider>Tarefas</Divider>
            {tasks.length > 0 && (
                <>
                    <Progress 
                        percent={progress}
                        className="mb-10"
                    />
                    <TodoList
                        tasks={tasks}
                        setTasks={setTasks}
                    />
                </>
            )}
            <Button onClick={() => setTasks([...tasks, { id: uid(), title: '' }])} style={{ marginTop: '24px' }}>
                <Icon type="folder-add" /> Adicionar Tarefa
            </Button>
        </Form>
        <div
            style={{
                position: 'absolute',
                bottom: 0,
                width: '100%',
                borderTop: '1px solid #e8e8e8',
                padding: '10px 16px',
                textAlign: 'right',
                left: 0,
                background: '#fff',
                borderRadius: '0 0 4px 4px',
            }}
        >
        {get(data, 'id') && (
            <Button 
                onClick={handleDelete} 
                type="danger" 
                loading={deleteLoading} 
                style={{ marginRight: '8px' }}>Deletar
            </Button>
        )}
        <Button
          style={{
            marginRight: 8,
          }}
          onClick={closeDrawer}
        >
          Fechar
        </Button>
        {(get(data, 'id')) && (
            <Button 
                onClick={handleSave} 
                type="primary" 
                loading={loading}>Salvar
            </Button>
        )}
        {!get(data, 'id') && (
            <Button 
                onClick={handleCreate} 
                type="primary" 
                loading={loading}>Cadastrar
            </Button>
        )}
      </div>
    </Drawer>
  )
}

const mapStateToProps = state => ({
  drawer: state.drawerMarketingBoard,
  marketing: state.marketing,
});

const mapDispatchProps = dispatch => ({
    dispatchClose: () => dispatch(drawerBoard.close()),
    dispatchCreate: (payload, boardType) => dispatch(drawerBoard.create(payload, boardType)),
    dispatchSave: (id, payload, boardType) => dispatch(drawerBoard.save(id, payload, boardType)),
    dispatchDelete: (payload, boardType) => dispatch(drawerBoard.remove(payload, boardType)),
});

export default connect(mapStateToProps, mapDispatchProps)(Form.create()(DrawerBoardItem));